import React from 'react'
import './feature.css'
import {FaGlobeAmericas} from 'react-icons/fa'
import {FaRegLightbulb} from 'react-icons/fa'
import {FaRegThumbsUp} from 'react-icons/fa'
import {FaTrophy} from 'react-icons/fa'
  import {FaUsers} from 'react-icons/fa'
import CountUp from '../countup/Countup'
const Feature = () => {
  return (
    <section className='info-section'>
      <div className="why-choose-us-text-container review-head-container">
            <div className="header review-header" data-aos="fade-up">
                <span className="header-line"></span>
                <h2>our statistics across the world</h2>
            </div>
            <h1 data-aos="fade-up">our statistics today</h1>
        </div>
      <div className="info-wrapper">
        <div className="info-left-card-container">
          <div className="info-left-card" data-aos="fade-up">
            <FaGlobeAmericas />
            <CountUp end={175} />
            <p>supported countries</p>
          </div>
        </div>
        <div className="info-right-card-container">
          <div className="info-right-card" data-aos="fade-up">
            <FaRegLightbulb />
            <CountUp end={19087} />
            <p>Secured Assets</p>
          </div>
          <div className="info-right-card" data-aos="fade-up">
            <FaRegThumbsUp  />
            <CountUp end={10954} />
            <p>Satisfied Users</p>
          </div>
          <div className="info-right-card" data-aos="fade-up">
            <FaTrophy />
            <CountUp end={13641} />
            <p>Global Awards</p>
          </div>
          <div className="info-right-card" data-aos="fade-up">
            <FaUsers   />
            <CountUp end={15040} />
            <p>Registered User</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Feature